import { Button } from "@/components/ui/button";
import { t } from "i18next";
import type { StripeCustomerSession } from "@/common/types/stripe";

interface Props {
  stripeSession: StripeCustomerSession;
}

export default function ManageSubscription(props: Props): JSX.Element {
  const handleClickManage = (): void => {
    window.open(props.stripeSession.url);
  };

  return (
    <div className="space-y-6">
      <p>{t("settings.subscription.manageSubscription.description")}</p>
      <Button onClick={handleClickManage}>
        {t("settings.subscription.manageSubscription.manageButton")}
      </Button>
    </div>
  );
}
